// 2023 Topps Star Wars Signature Series — the all-autograph product (released
// March 31, 2023; 1 encased autograph per box, 1 card per pack, 20 boxes per case).
// Cards verified against the official Topps checklist PDF
// (2023StarWarsSignatureSeriesChecklist.pdf); parallels cross-checked against
// Beckett and Cardboard Connection. Design B uses the 1983 Topps Return of the
// Jedi design for the ROTJ 40th anniversary.
// The official PDF lists Design A as two alphabetical blocks under one header
// (the base list plus later additions); merged and sorted by code here, matching
// how Beckett and Cardboard Connection present it.
// Red 1/1 is the top tier for BOTH designs per Beckett and TCDB; Cardboard
// Connection alone calls Design B's 1/1 "Ruby Plate Wash" — treated as CC's
// quirk, no specimen either way (1/1s rarely surface).
// Code quirk kept verbatim: the two designs assign initials independently —
// A-AE is Alden Ehrenreich but AB-AE is Ashley Eckstein; A-RO is Rena Owen but
// AB-RO is Ron Perlman.
// Quad autographs have no parallels — the base card IS the 1/1 (shown via the
// unnamed /1 slot below).

export const SETS = [
  {
    id: "autographs-design-a", type: "auto", title: "AUTOGRAPHS DESIGN A — 134 CARDS",
    parallels: [
      {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:25,color:"#00e676"},
      {id:"orange",name:"Orange",print_run:10,color:"#ff9100"},
      {id:"black",name:"Black",print_run:5,color:"#a8a8b4"},
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"A-AB", name:"Ahmed Best", artist:"Jar Jar Binks"},
      {n:"A-ABA", name:"Andrea Bartlow", artist:"Twi'lek Server"},
      {n:"A-AC", name:"Aidan Cook", artist:"Strono \"Cookie\" Tuggs"},
      {n:"A-AD", name:"Adam Driver", artist:"Kylo Ren"},
      {n:"A-AE", name:"Alden Ehrenreich", artist:"Han Solo"},
      {n:"A-AEC", name:"Ashley Eckstein", artist:"Ahsoka Tano"},
      {n:"A-AG", name:"Allan Graf", artist:"Bartender"},
      {n:"A-AH", name:"Alfred Hsing", artist:"Pyke Traveler"},
      {n:"A-AK", name:"Andrew Kishino", artist:"Izuma"},
      {n:"A-AP", name:"Alistair Petrie", artist:"General Draven"},
      {n:"A-APE", name:"Angelique Perrin", artist:"Adi Gallia"},
      {n:"A-AS", name:"Andy Serkis", artist:"Supreme Leader Snoke"},
      {n:"A-ASE", name:"Amy Sedaris", artist:"Peli Motto"},
      {n:"A-AT", name:"Alan Tudyk", artist:"K-2SO"},
      {n:"A-AW", name:"Alexander Wraith", artist:"Imperial Freighter Pilot"},
      {n:"A-BB", name:"Bernard Bullen", artist:"Father of the Mandalorian"},
      {n:"A-BD", name:"Ben Diskin", artist:"AZI-3"},
      {n:"A-BH", name:"Brian Herring", artist:"BB-8"},
      {n:"A-BL", name:"Billie Lourd", artist:"Kaydel Ko Connix"},
      {n:"A-BLO", name:"Barry Lowin", artist:"Garfalaquox"},
      {n:"A-BM", name:"Ben Mendelsohn", artist:"Director Krennic"},
      {n:"A-BP", name:"Bonnie Piesse", artist:"Beru Lars"},
      {n:"A-CB", name:"Chris Bartlett", artist:"Zero"},
      {n:"A-CBL", name:"Caroline Blakiston", artist:"Mon Mothma"},
      {n:"A-CC", name:"Crystal Clarke", artist:"Pammich Nerro Goode"},
      {n:"A-CE", name:"Chris Edgerly", artist:"Eeth Koth"},
      {n:"A-CH", name:"Clint Howard", artist:"Ralakili"},
      {n:"A-CJ", name:"Carey Jones", artist:"Krrsantan"},
      {n:"A-CL", name:"Charlotte Louise", artist:"Margo"},
      {n:"A-CP", name:"Chris Parsons", artist:"4-LOM"},
      {n:"A-CS", name:"Christopher Sean", artist:"Kazuda Xiono"},
      {n:"A-CW", name:"Carl Weathers", artist:"Greef Karga"},
      {n:"A-CWI", name:"Corey Dee Williams", artist:"Klaatu"},
      {n:"A-DA", name:"David Acord", artist:"Edrio Two Tubes"},
      {n:"A-DBI", name:"Dmitrious Bistrevsky", artist:"Quarren Trawler"},
      {n:"A-DC", name:"Dave Chapman", artist:"BB-8"},
      {n:"A-DG", name:"Domhnall Gleeson", artist:"General Hux"},
      {n:"A-DK", name:"Dorian Kingi", artist:"Cad Bane"},
      {n:"A-DLU", name:"Diego Luna", artist:"Cassian Andor"},
      {n:"A-DM", name:"Dominic Monaghan", artist:"Beaumont Kin"},
      {n:"A-DP", name:"David Pasquesi", artist:"Twi'lek Majordomo"},
      {n:"A-DY", name:"Donnie Yen", artist:"Chirrut Îmwe"},
      {n:"A-EC", name:"Emilia Clarke", artist:"Qi'ra"},
      {n:"A-EK", name:"Erin Kellyman", artist:"Enfys Nest"},
      {n:"A-EM", name:"Ewan McGregor", artist:"Obi-Wan Kenobi"},
      {n:"A-FJ", name:"Felicity Jones", artist:"Jyn Erso"},
      {n:"A-FP", name:"Freddie Prinze Jr.", artist:"Kanan Jarrus"},
      {n:"A-GE", name:"Giancarlo Esposito", artist:"Moff Gideon"},
      {n:"A-GH", name:"Guy Henry", artist:"Grand Moff Tarkin"},
      {n:"A-GT", name:"Gina Torres", artist:"Ketsu Onyo"},
      {n:"A-GTA", name:"George Takei", artist:"Lok Durd"},
      {n:"A-HCO", name:"Hermione Corfield", artist:"Tallie Lintra"},
      {n:"A-HD", name:"Harrison Davis", artist:"Pommet Warrick"},
      {n:"A-HF", name:"Harrison Ford", artist:"Han Solo"},
      {n:"A-HQ", name:"Hugh Quarshie", artist:"Captain Panaka"},
      {n:"A-JA", name:"Josef Altin", artist:"Seftin Vanik"},
      {n:"A-JB", name:"John Boyega", artist:"Finn"},
      {n:"A-JBE", name:"Joanna Bennett", artist:"Tusken Warrior"},
      {n:"A-JC", name:"Jim Cummings", artist:"Hondo Ohnaka"},
      {n:"A-JD", name:"Julie Dolan", artist:"Princess Leia Organa"},
      {n:"A-JG", name:"Julian Glover", artist:"General Veers"},
      {n:"A-JK", name:"Jaime King", artist:"Aurra Sing"},
      {n:"A-JL", name:"John Leguizamo", artist:"Gor Koresh"},
      {n:"A-JR", name:"John Rosengrant", artist:"Mayor Mok Shaiz"},
      {n:"A-JS", name:"Jason Spisak", artist:"Lux Bonteri"},
      {n:"A-JW", name:"Jaden Waldman", artist:"T0-B1"},
      {n:"A-KB", name:"Kenny Baker", artist:"R2-D2"},
      {n:"A-KF", name:"Karen Fukuhara", artist:"F"},
      {n:"A-KG", name:"Kathleen Gati", artist:"Old Daka"},
      {n:"A-KK", name:"Katy Kartwheel", artist:"Rio Durant"},
      {n:"A-KO", name:"Katy O'Brian", artist:"Imperial Comms Officer"},
      {n:"A-KS", name:"Kiran Shah", artist:"Nambi Ghima"},
      {n:"A-KT", name:"Kelly Marie Tran", artist:"Rose Tico"},
      {n:"A-LC", name:"Lily Cole", artist:"Lovey"},
      {n:"A-LD", name:"Laura Dern", artist:"Vice Admiral Holdo"},
      {n:"A-LM", name:"Lars Mikkelsen", artist:"Grand Admiral Thrawn"},
      {n:"A-LN", name:"Lupita Nyong'o", artist:"Maz Kanata"},
      {n:"A-LT", name:"Lee Towersey", artist:"R2-D2"},
      {n:"A-LW", name:"Leeanna Walsman", artist:"Zam Wesell"},
      {n:"A-MB", name:"Matt Berry", artist:"8D8"},
      {n:"A-MBO", name:"Michonne Bourriague", artist:"Aurra Sing"},
      {n:"A-MC", name:"Michaela Cottrell", artist:"Even Piell"},
      {n:"A-MCU", name:"Michael Culver", artist:"Captain Needa"},
      {n:"A-ME", name:"Mike Edmonds", artist:"Logray"},
      {n:"A-ML", name:"Matt Lanter", artist:"Anakin Skywalker"},
      {n:"A-MM", name:"Mads Mikkelsen", artist:"Galen Erso"},
      {n:"A-MMC", name:"Mary Elizabeth McGlynn", artist:"Governor Arihnda Pryce"},
      {n:"A-MQ", name:"Mike Quinn", artist:"Nien Nunb"},
      {n:"A-MV", name:"Mercedes Varnado", artist:"Koska Reeves"},
      {n:"A-MW", name:"Ming-Na Wen", artist:"Fennec Shand"},
      {n:"A-MWO", name:"Matthew Wood", artist:"General Grievous"},
      {n:"A-NA", name:"Naomi Ackie", artist:"Jannah"},
      {n:"A-NF", name:"Nika Futterman", artist:"Asajj Ventress"},
      {n:"A-NN", name:"Nick Nolte", artist:"Kuiil"},
      {n:"A-NP", name:"Natalie Portman", artist:"Padmé Amidala"},
      {n:"A-OA", name:"Omid Abtahi", artist:"Dr. Pershing"},
      {n:"A-OD", name:"Olivia d'Abo", artist:"Luminara Unduli"},
      {n:"A-ODA", name:"Oliver Ford Davies", artist:"Governor Sio Bibble"},
      {n:"A-PA", name:"Philip Alexander", artist:"Imperial Security Officer"},
      {n:"A-PAN", name:"Philip Anthony-Rodriguez", artist:"Fifth Brother"},
      {n:"A-PD", name:"Paul Darnell", artist:"Night Wind Assassin"},
      {n:"A-PK", name:"Paul Kasey", artist:"C'ai Threnalli"},
      {n:"A-PLE", name:"Paul Sun-Hyung Lee", artist:"Carson Teva"},
      {n:"A-PRE", name:"Paul Reubens", artist:"RX-24"},
      {n:"A-PW", name:"Paul Warren", artist:"Hassk Triplet"},
      {n:"A-RA", name:"Riz Ahmed", artist:"Bodhi Rook"},
      {n:"A-RB", name:"Ralph Brown", artist:"Ric Olié"},
      {n:"A-RBR", name:"Richard Brake", artist:"Valin Hess"},
      {n:"A-RD", name:"Rosario Dawson", artist:"Ahsoka Tano"},
      {n:"A-RDO", name:"Robin Atkin Downes", artist:"Cham Syndulla"},
      {n:"A-RG", name:"Richard E. Grant", artist:"Allegiant General Pryde"},
      {n:"A-RO", name:"Rena Owen", artist:"Taun We"},
      {n:"A-RP", name:"Ray Park", artist:"Darth Maul"},
      {n:"A-RPE", name:"Ron Perlman", artist:"Gha Nachkt"},
      {n:"A-RW", name:"Ryan Watson", artist:"Beta Trawler"},
      {n:"A-SB", name:"Steve Blum", artist:"Zeb Orrelios"},
      {n:"A-SBI", name:"Skyler Bible", artist:"Fixer"},
      {n:"A-SC", name:"Scott Capurro", artist:"Beed"},
      {n:"A-SGE", name:"Sarah Michelle Gellar", artist:"Seventh Sister"},
      {n:"A-SK", name:"Simon Kassianides", artist:"Axe Woves"},
      {n:"A-SL", name:"Scott Lawrence", artist:"Jarek Yeager"},
      {n:"A-SS", name:"Stephen Stanton", artist:"Ben Kenobi"},
      {n:"A-SW", name:"Sam Witwer", artist:"Maul"},
      {n:"A-TB", name:"Tom Baker", artist:"Bendu"},
      {n:"A-TC", name:"Tim Curry", artist:"Chancellor Palpatine"},
      {n:"A-TG", name:"Taylor Gray", artist:"Ezra Bridger"},
      {n:"A-TM", name:"Temuera Morrison", artist:"Boba Fett"},
      {n:"A-TR", name:"Tim Rose", artist:"Admiral Ackbar"},
      {n:"A-TW", name:"Taika Waititi", artist:"IG-11"},
      {n:"A-VK", name:"Valene Kane", artist:"Lyra Erso"},
      {n:"A-VM", name:"Vanessa Marshall", artist:"Hera Syndulla"},
      {n:"A-WB", name:"W. Earl Brown", artist:"Taanti"},
      {n:"A-WD", name:"Warwick Davis", artist:"Wicket W. Warrick"},
      {n:"A-WH", name:"Werner Herzog", artist:"The Client"},
    ]
  },
  {
    id: "autographs-design-b", type: "auto", title: "AUTOGRAPHS DESIGN B (1983 ROTJ 40TH) — 67 CARDS",
    parallels: [
      {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:25,color:"#00e676"},
      {id:"orange",name:"Orange",print_run:10,color:"#ff9100"},
      {id:"black",name:"Black",print_run:5,color:"#a8a8b4"},
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"AB-AB", name:"Ahmed Best", artist:"Jar Jar Binks"},
      {n:"AB-AD", name:"Adam Driver", artist:"Kylo Ren"},
      {n:"AB-AE", name:"Ashley Eckstein", artist:"Ahsoka Tano"},
      {n:"AB-AG", name:"Allan Graf", artist:"Bartender"},
      {n:"AB-AH", name:"Alfred Hsing", artist:"Pyke Traveler"},
      {n:"AB-AS", name:"Andy Serkis", artist:"Supreme Leader Snoke"},
      {n:"AB-BH", name:"Brian Herring", artist:"BB-8"},
      {n:"AB-BL", name:"Billie Lourd", artist:"Kaydel Ko Connix"},
      {n:"AB-BM", name:"Ben Mendelsohn", artist:"Director Krennic"},
      {n:"AB-BP", name:"Bonnie Piesse", artist:"Beru Lars"},
      {n:"AB-CH", name:"Clint Howard", artist:"Ralakili"},
      {n:"AB-CW", name:"Carl Weathers", artist:"Greef Karga"},
      {n:"AB-DA", name:"David Acord", artist:"Edrio Two Tubes"},
      {n:"AB-DG", name:"Domhnall Gleeson", artist:"General Hux"},
      {n:"AB-DL", name:"Daniel Logan", artist:"Boba Fett"},
      {n:"AB-DY", name:"Donnie Yen", artist:"Chirrut Îmwe"},
      {n:"AB-EC", name:"Emilia Clarke", artist:"Qi'ra"},
      {n:"AB-EK", name:"Erin Kellyman", artist:"Enfys Nest"},
      {n:"AB-EM", name:"Ewan McGregor", artist:"Obi-Wan Kenobi"},
      {n:"AB-ES", name:"Emily Swallow", artist:"The Armorer"},
      {n:"AB-FJ", name:"Felicity Jones", artist:"Jyn Erso"},
      {n:"AB-GH", name:"Guy Henry", artist:"Grand Moff Tarkin"},
      {n:"AB-GT", name:"Gina Torres", artist:"Ketsu Onyo"},
      {n:"AB-HC", name:"Hayden Christensen", artist:"Darth Vader"},
      {n:"AB-HD", name:"Harrison Davis", artist:"Pommet Warrick"},
      {n:"AB-HE", name:"Hermione Corfield", artist:"Tallie Lintra"},
      {n:"AB-HF", name:"Harrison Ford", artist:"Han Solo"},
      {n:"AB-JA", name:"Josef Altin", artist:"Seftin Vanik"},
      {n:"AB-JB", name:"John Boyega", artist:"Finn"},
      {n:"AB-JC", name:"Jim Cummings", artist:"Hondo Ohnaka"},
      {n:"AB-JS", name:"Jason Spisak", artist:"Lux Bonteri"},
      {n:"AB-KB", name:"Kenny Baker", artist:"R2-D2"},
      {n:"AB-KF", name:"Karen Fukuhara", artist:"F"},
      {n:"AB-KK", name:"Katy Kartwheel", artist:"Rio Durant"},
      {n:"AB-KS", name:"Kiran Shah", artist:"Nambi Ghima"},
      {n:"AB-KT", name:"Kelly Marie Tran", artist:"Rose Tico"},
      {n:"AB-LC", name:"Lily Cole", artist:"Lovey"},
      {n:"AB-LD", name:"Laura Dern", artist:"Vice Admiral Holdo"},
      {n:"AB-LN", name:"Lupita Nyong'o", artist:"Maz Kanata"},
      {n:"AB-MA", name:"Matthew Wood", artist:"General Grievous"},
      {n:"AB-MB", name:"Matt Berry", artist:"8D8"},
      {n:"AB-ML", name:"Matt Lanter", artist:"Anakin Skywalker"},
      {n:"AB-MM", name:"Mads Mikkelsen", artist:"Galen Erso"},
      {n:"AB-MV", name:"Mercedes Varnado", artist:"Koska Reeves"},
      {n:"AB-MW", name:"Ming-Na Wen", artist:"Fennec Shand"},
      {n:"AB-NF", name:"Nika Futterman", artist:"Asajj Ventress"},
      {n:"AB-NN", name:"Nick Nolte", artist:"Kuiil"},
      {n:"AB-NP", name:"Natalie Portman", artist:"Padmé Amidala"},
      {n:"AB-PA", name:"Philip Alexander", artist:"Imperial Security Officer"},
      {n:"AB-PD", name:"Paul Darnell", artist:"Night Wind Assassin"},
      {n:"AB-PW", name:"Paul Warren", artist:"Hassk Triplet"},
      {n:"AB-RA", name:"Riz Ahmed", artist:"Bodhi Rook"},
      {n:"AB-RB", name:"Richard Brake", artist:"Valin Hess"},
      {n:"AB-RD", name:"Rosario Dawson", artist:"Ahsoka Tano"},
      {n:"AB-RDO", name:"Robin Atkin Downes", artist:"Cham Syndulla"},
      {n:"AB-RO", name:"Ron Perlman", artist:"Gha Nachkt"},
      {n:"AB-SC", name:"Scott Capurro", artist:"Beed"},
      {n:"AB-SG", name:"Sarah Michelle Gellar", artist:"Seventh Sister"},
      {n:"AB-SW", name:"Sam Witwer", artist:"Maul"},
      {n:"AB-TB", name:"Tom Baker", artist:"Bendu"},
      {n:"AB-TC", name:"Tim Curry", artist:"Chancellor Palpatine"},
      {n:"AB-TM", name:"Temuera Morrison", artist:"Boba Fett"},
      {n:"AB-TR", name:"Tim Rose", artist:"Admiral Ackbar"},
      {n:"AB-TW", name:"Taika Waititi", artist:"IG-11"},
      {n:"AB-VK", name:"Valene Kane", artist:"Lyra Erso"},
      {n:"AB-VM", name:"Vanessa Marshall", artist:"Hera Syndulla"},
      {n:"AB-WD", name:"Warwick Davis", artist:"Wicket W. Warrick"},
    ]
  },
  {
    id: "dual-autographs", type: "auto", title: "DUAL AUTOGRAPHS — 3 CARDS",
    parallels: [
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"DA-JW", name:"Carey Jones / Ming-Na Wen", artist:"Krrsantan / Fennec Shand"},
      {n:"DA-MW", name:"Ming-Na Wen / Temuera Morrison", artist:"Fennec Shand / Boba Fett"},
      {n:"DA-RD", name:"Adam Driver / Daisy Ridley", artist:"Kylo Ren / Rey"},
    ]
  },
  {
    id: "triple-autographs", type: "auto", title: "TRIPLE AUTOGRAPHS — 3 CARDS",
    parallels: [
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"TA-JWM", name:"Carey Jones / Temuera Morrison / Ming-Na Wen", artist:"Krrsantan / Boba Fett / Fennec Shand"},
      {n:"TA-PWM", name:"Ewan McGregor / Ian McDiarmid / Ray Park", artist:"Obi-Wan Kenobi / Darth Sidious / Darth Maul"},
      {n:"TA-RDB", name:"Adam Driver / Daisy Ridley / John Boyega", artist:"Kylo Ren / Rey / Finn"},
    ]
  },
  {
    id: "light-side-dark-side-quad-autographs", type: "auto", title: "LIGHT SIDE / DARK SIDE QUAD AUTOGRAPHS — 2 CARDS",
    parallels: [
      {id:"base",name:"",print_run:1,color:"#c8d8f0"},
    ],
    cards: [
      {n:"LDA-PMWM", name:"Ewan McGregor / Matthew Wood / Ian McDiarmid / Natalie Portman", artist:"Obi-Wan Kenobi / General Grievous / Darth Sidious / Padmé Amidala"},
      {n:"LDA-RFDS", name:"Andy Serkis / Harrison Ford / Adam Driver / Daisy Ridley", artist:"Supreme Leader Snoke / Han Solo / Kylo Ren / Rey"},
    ]
  },
];
